import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../common/Icons';
import CreateCompanyCityModal from './CreateCompanyCityModal';
import './AffiliationBadge.css';

export default function CompanyCitySelect({
  id = 'co-city',
  name = 'city_id',
  value,
  onChange,
  cities = [],
  defaultCity = null,
  className = 'co-aff-select',
  required = false,
  disabled = false,
  loading = false,
  loadError = '',
  canAddNew = true,
  onReloadCities
}) {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const selectedId =
    value != null && value !== ''
      ? String(value)
      : defaultCity?.id != null
        ? String(defaultCity.id)
        : '';

  const selected = cities.find((c) => String(c.id) === selectedId);
  const hasCities = cities.length > 0;
  const selectDisabled = disabled || loading;

  const handleSelectChange = (event) => {
    onChange?.(event);
  };

  const handleCityCreated = async (createdOption) => {
    if (typeof onReloadCities === 'function') {
      await onReloadCities();
    }
    if (onChange && createdOption?.id != null) {
      onChange({
        target: {
          name,
          value: String(createdOption.id)
        }
      });
    }
  };

  const modalNode =
    canAddNew && typeof document !== 'undefined'
      ? createPortal(
          <CreateCompanyCityModal
            show={showCreateModal}
            onHide={() => setShowCreateModal(false)}
            onCreated={handleCityCreated}
          />,
          document.body
        )
      : null;

  const selectValue = hasCities ? selectedId : '';

  return (
    <div className="co-city-field">
      <div className="co-aff-select-wrap">
        <select
          id={id}
          name={name}
          className={`${className} co-city-select co-aff-select--main`}
          value={selectValue}
          onChange={handleSelectChange}
          required={required}
          disabled={selectDisabled}
          aria-label="Ville de la société"
          aria-describedby={`${id}-city-hint`}
        >
          {loading ? (
            <option value="">Chargement des villes…</option>
          ) : (
            <>
              {hasCities && !selectedId ? (
                <option value="" disabled>
                  Choisir une ville…
                </option>
              ) : null}
              {!hasCities && !canAddNew ? (
                <option value="">Aucune ville disponible</option>
              ) : null}
              {cities.map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.label}
                </option>
              ))}
            </>
          )}
        </select>
        {loading ? (
          <span className="co-aff-select-spinner" aria-hidden>
            <span className="spinner-border spinner-border-sm text-primary" />
          </span>
        ) : null}
      </div>

      {canAddNew ? (
        <button
          type="button"
          className="co-city-add-btn"
          onClick={() => setShowCreateModal(true)}
          disabled={selectDisabled}
        >
          <span aria-hidden>＋</span>
          Nouvelle ville
        </button>
      ) : null}

      {loadError ? (
        <p className="co-aff-field-error" role="alert">
          <Icon name="exclamationTriangle" size={14} />
          {loadError}
        </p>
      ) : null}

      <p id={`${id}-city-hint`} className="co-aff-select-hint">
        {selected
          ? `Ville : ${selected.label}`
          : 'Sélectionnez une ville existante ou ajoutez-la au référentiel.'}
      </p>

      {modalNode}
    </div>
  );
}
